var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgX = function SvgX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.364.929a1 1 0 0 1 1.414 1.414l-6.364 6.363 6.364 6.365a1.001 1.001 0 0 1-1.414 1.415L8.999 10.12l-6.363 6.365a1 1 0 0 1-1.414-1.415l6.363-6.365-6.363-6.363A1 1 0 1 1 2.636.929L9 7.292z"
  })));
};
export default SvgX;